import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from "@/views/Home";
import MainWorks from "@/views/MainWorks";
import Contact from "@/views/Contact";
import Resume from "@/views/Resume";
import HC3P from "@/views/HC3P";
import Digrab from "@/views/Digrab"
import Website from "@/views/Website";

Vue.use(VueRouter)

  const routes = [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path:'/HC3P',
      name:'HC3P',
      component: HC3P
    },
    {
      path:'/Digrab',
      name: 'Digrab',
      component: Digrab
    },
    {
      path:"/MainWorks",
      name:"MainWorks",
      component: MainWorks
    },
    {
      path:"/Contact",
      name:"Contact",
      component: Contact
    },
    {
      path:"/Resume",
      name:"Resume",
      component: Resume
    },
    {
      path:"/Website",
      name:"Website",
      component: Website
    },
    {
      path:"*",
      redirect: "/"
    }
]

const router = new VueRouter({
  scrollBehavior(){
    return {x: 0, y: 0};
  },
  routes
})

export default router
